import React, { useEffect, useState } from "react";
import { Container, Boxs, Table } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdVisibility, MdDelete, MdEdit, MdLink } from "react-icons/md";
import { useAuth } from "../../../hooks/AuthContext";
import { format } from "date-fns";
import { useQuery } from "../../../hooks/Location";
import { Button, Input, Pagination, Spin, Modal, Tooltip } from "antd";
import { Card, Message, ViewInput } from "../../../GlobalStyles";
import Status from "../../../components/status";
import copy from "copy-to-clipboard";

import { ExclamationCircleFilled } from "@ant-design/icons";
import CountUp from "react-countup";
const { confirm } = Modal;

export default function Contracts() {
  const { user } = useAuth();

  const query = useQuery();
  const lead = query.get("lead");
  const name = query.get("name");

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");
  const [status, setStatus] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [page, setPage] = useState(0);
  const [contracts, setContracts] = useState([]);
  const [totalContracts, setTotalContracts] = useState(0);
  const [infosContracts, setInfosContracts] = useState({});

  useEffect(() => {
    if (user.type == "tecnico") {
      navigate(-1);
    } else {
      if (user.restricted) {
        toast.warn("Área restrita para franqueados");
        navigate(-1);
      } else {
        listContracts(page, filterSearch, status);
      }
    }
  }, [page, filterSearch, status]);

  async function listContracts(page, search, status) {
    setLoading(true);
    let url = `/contracts?page=${page}`;
    if (search) {
      url += `&search=${search}`;
    }
    if (lead) {
      url += `&lead_id=${lead}`;
    }
    if (status) {
      url += `&status=${status}`;
    }
    await api
      .get(url)
      .then((response) => {
        setContracts(response.data.contracts);
        setTotalContracts(response.data.totalContracts);
        setInfosContracts(response.data.infosContracts);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function deleteContract(id) {
    await api
      .delete(`/contract/${id}`)
      .then(() => {
        toast.success("Contrato excluido com sucesso");
        listContracts(0, "", status);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <h1>Contratos {name ? `(${name})` : ""}</h1>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 50 }}>
          <Spin size="large" color="#008037" />
        </div>
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={contracts.length} />
          </Card>
          <div className="filters-row">
            <ViewInput style={{ flex: 1, maxWidth: 350 }}>
              <p>Pesquisar por Razão Social</p>
              <Input.Search
                value={filter}
                onChange={(text) => {
                  setFilter(text.target.value);
                }}
                placeholder="pesquisar"
                onSearch={(text) => {
                  setFilterSearch(text);
                  setPage(0);
                }}
                allowClear
                onClear={() => {
                  setFilterSearch("");
                  setPage(0);
                  setFilter("");
                }}
                enterButton
              />
            </ViewInput>
            <Button
              type="primary"
              style={{
                borderRadius: 50,
                marginBottom: 5,
              }}
              onClick={() => {
                navigate(`/new-contract${lead ? `?lead=${lead}` : ""}`);
              }}
            >
              Novo Contrato
            </Button>
          </div>

          <Boxs>
            <div
              style={{ background: "#46E961" }}
              className={status == "assinado" ? "active" : ""}
              onClick={() => {
                if (status == "assinado") {
                  setStatus("");
                } else {
                  setStatus("assinado");
                }
              }}
            >
              <p>Assinados {infosContracts?.totalContractsSigned || 0}</p>
            </div>
            <div
              style={{ background: "#46ADE9" }}
              className={status == "aguardando" ? "active" : ""}
              onClick={() => {
                if (status == "aguardando") {
                  setStatus("");
                } else {
                  setStatus("aguardando");
                }
              }}
            >
              <p>Aguardando {infosContracts?.totalContractsPedding || 0}</p>
            </div>
            <div
              style={{ background: "#FFBB45" }}
              className={status == "negociacao" ? "active" : ""}
              onClick={() => {
                if (status == "negociacao") {
                  setStatus("");
                } else {
                  setStatus("negociacao");
                }
              }}
            >
              <p>Em Negociação {infosContracts?.totalContractsNegotion || 0}</p>
            </div>
            <div
              style={{ background: "#9D9D9D" }}
              className={status == "expirado" ? "active" : ""}
              onClick={() => {
                if (status == "expirado") {
                  setStatus("");
                } else {
                  setStatus("expirado");
                }
              }}
            >
              <p>Expirados {infosContracts?.totalContractsExpired || 0}</p>
            </div>
            <div
              style={{ background: "#FF5D5D" }}
              className={status == "recusado" ? "active" : ""}
              onClick={() => {
                if (status == "recusado") {
                  setStatus("");
                } else {
                  setStatus("recusado");
                }
              }}
            >
              <p>Recusados {infosContracts?.totalContractsRecused || 0}</p>
            </div>
          </Boxs>
          {contracts.length === 0 ? (
            <div
              style={{
                background: "#fff",
                padding: 50,
                borderRadius: 15,
                textAlign: "center",
                border: "1px solid #eee",
              }}
            >
              <Message>Nenhum contrato encontrado.</Message>
            </div>
          ) : (
            <div className="contracts-list">
              {contracts.map((item) => (
                <div className="contract-card" key={item.id}>
                  <div className="main-info">
                    <Tooltip title={item.name}>
                      <strong>{item.name}</strong>
                    </Tooltip>
                    <span>Contrato</span>
                  </div>

                  <div className="info-item">
                    <label>Telefone</label>
                    <span>{item.phone_number || "Não informado"}</span>
                  </div>

                  <div className="info-item">
                    <label>Status</label>
                    <Status
                      status={item.status}
                      isPayment={false}
                      style={{
                        fontSize: 10,
                        height: 18,
                        paddingBottom: 2,
                        width: "fit-content",
                      }}
                    />
                  </div>

                  <div className="info-item">
                    <label>Data de Criação</label>
                    <span>
                      {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                    </span>
                  </div>

                  <div className="actions">
                    <Tooltip title="Visualizar">
                      <Button
                        shape="circle"
                        icon={<MdVisibility size={18} />}
                        onClick={() => navigate(`/contract/${item.id}`)}
                      />
                    </Tooltip>
                    <Tooltip title="Copiar Link">
                      <Button
                        shape="circle"
                        icon={<MdLink size={18} />}
                        onClick={() => {
                          copy(
                            `https://app.gurusegead.com.br/contract/${item.id}`,
                          );
                          toast.success(
                            "Link do contrato copiado com sucesso!",
                          );
                        }}
                      />
                    </Tooltip>
                    {item.status !== "assinado" && (
                      <>
                        <Tooltip title="Editar">
                          <Button
                            shape="circle"
                            icon={<MdEdit size={18} />}
                            onClick={() =>
                              navigate(`/edit-contract/${item.id}`)
                            }
                          />
                        </Tooltip>
                        <Tooltip title="Excluir">
                          <Button
                            shape="circle"
                            danger
                            icon={<MdDelete size={18} />}
                            onClick={() => {
                              confirm({
                                okText: "Confirmar",
                                title: `Deseja excluir o contrato de ${item.name}?`,
                                icon: <ExclamationCircleFilled />,
                                content: `Após confirmação o contrato será excluido`,
                                onOk() {
                                  deleteContract(item.id);
                                },
                                onCancel() {},
                                cancelText: "Cancelar",
                              });
                            }}
                          />
                        </Tooltip>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
      <Pagination
        style={{
          margin: "25px 0",
          alignSelf: "center",
        }}
        defaultCurrent={page + 1}
        pageSize={30}
        onChange={(page) => {
          setPage(page - 1);
        }}
        total={totalContracts}
      />
    </Container>
  );
}
